import { CommonModule, formatDate } from '@angular/common';
import { Component, inject, input, OnChanges, signal, SimpleChanges, viewChild } from '@angular/core';
import { AddResumeEducation, AddResumeSkill } from 'src/app/models/resume/add-resume';
import { ModalEducationComponent } from "./modal-education/modal-education.component";
import { ModalSkillComponent } from "../cv-skills/modal-skill/modal-skill.component";
import { ModalLanguageComponent } from '../cv-skills/modal-language/modal-language.component';
import { ResumeService } from 'src/app/services/resume.service';
import { ResumeEducation, ResumeLanguage, ResumeSkill } from 'src/app/models/resume/resume';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cv-educations',
  imports: [CommonModule, ModalEducationComponent],
  templateUrl: './cv-educations.component.html',
  styleUrl: './cv-educations.component.css',
  standalone: true
})
export class CvEducationsComponent implements OnChanges {
  public resumeId = input<number | null>(null);
  educations = signal<ResumeEducation[]>([]);

  indexResume = signal<number | null>(null);

  modalEducationComponent = viewChild(ModalEducationComponent);

  private readonly resumeService = inject(ResumeService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resumeId']?.currentValue) {
      this.getResumeEducations();
    }
  }

  getResumeEducations() {
    const resumeId = this.resumeId();
    if (!resumeId) {
      return;
    }
    this.resumeService.getResumeEducations(resumeId).subscribe({
      next: res => {
        this.educations.set(res);
      }
    });
  }

  add() {
    this.indexResume.set(null);
    if (this.modalEducationComponent()) {
      this.modalEducationComponent()?.reset();
    }
  }

  editResumeEducation(resumeEducation: AddResumeEducation, index: number) {
    this.indexResume.set(index);
    if (this.modalEducationComponent()) {
      this.modalEducationComponent()?.form.patchValue({
        ...resumeEducation as any,
        startDate: formatDate(resumeEducation.startDate, 'yyyy-MM-dd', 'en'),
        endDate: resumeEducation.endDate ? formatDate(resumeEducation.endDate, 'yyyy-MM-dd', 'en') : null
      });
      this.modalEducationComponent()?.changeStatus();
    }
  }

  deleteResumeEducation(resumeEducation: ResumeEducation, index: number) {
    const resumeId = this.resumeId();
    const id = resumeEducation.id ?? 0;

    if (!resumeId) {
      this.educations.update(value => value?.filter((education, i) => i !== index));
      return;
    } 

    Swal.fire({
      title: 'Eliminar',
      text: '¿Desea eliminar este registro?',
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: '#0d1174',
      cancelButtonColor: '#3a3a3a',
      confirmButtonText: 'Eliminar'
    }).then((resultmodal) => {
      if (resultmodal.isConfirmed) {
        this.resumeService.deleteResumeEducation(id).subscribe({
          next: res => {
            this.educations.update(educations => educations.filter(education => education.id !== id));
          }, error: res => {
            Swal.fire({
              title: 'Error',
              text: 'Ocurrió un error al eliminar el registro.',
              icon: 'error',
              confirmButtonColor: '#d33'
            });
          }
        })
      } 
    });
  }

  handlerResumeEducation(resumeEducation: ResumeEducation) {
    const resumeId = this.resumeId();
    if(resumeId){
      this.getResumeEducations();
      return;
    }
    if (this.indexResume() != null || resumeEducation.id) {
      this.educations.update(value => value?.map((education, i) => {
        if (i === this.indexResume() || education.id === resumeEducation.id) {
          return resumeEducation
        }
        return education;
      }));
      return;
    }
    this.educations.set([...this.educations(), resumeEducation]);
  }

}